
export const GET_STATION_REQUEST = "GET_STATION_REQUEST";
export const GET_STATION_SUCCESS = "GET_STATION_SUCCESS";
export const GET_STATION_FAILURE = "GET_STATION_FAILURE";